import React from 'react';

import { observer } from 'mobx-react-lite';
import { Tooltip, Button } from '@bringg/react-components';

import { NO_ROUTE_ID } from '../../../../../../stores/routes-planner-store';
import { RouteRowTranslations } from '../../../../../routes-planner/translations';
import { OpenUserAssignerProps } from '../../../../../../types/routes-planner-app';
import useStore from '../../../../../../stores/helpers/use-context';

import './driver-cell.scss';

interface Props {
	driverName?: string;
	runId: number;
	translations: RouteRowTranslations;
	openUserAssignerModal?: (props: OpenUserAssignerProps) => void;
}

const DriverCell = ({ driverName, runId, translations, openUserAssignerModal }: Props) => {
	const driverNameTitle = `${driverName ?? translations.unassigned}`;

	const stopPropagation = e => {
		e.stopPropagation();
	};

	const { updateDriverOnRun } = useStore();

	const onDriverNameClick = () => {
		openUserAssignerModal({ runId, onClose: updateDriverOnRun });
	};

	return (
		<div className="route-row-item driver-name">
			{runId !== NO_ROUTE_ID && driverName ? (
				<Tooltip
					key="route-row-driver-name"
					title={driverNameTitle}
					placement="top"
					overlayClassName="route-row-driver-name"
				>
					{openUserAssignerModal ? (
						<Button
							type="link"
							className="route-row-driver-name-link"
							data-test-id="route-row-driver-name-link"
							onClick={e => {
								onDriverNameClick();
								stopPropagation(e);
							}}
						>
							{driverNameTitle}
						</Button>
					) : (
						<span className="route-row-driver-name-without-link">{driverNameTitle}</span>
					)}
				</Tooltip>
			) : (
				<div>-</div>
			)}
		</div>
	);
};

export default observer(DriverCell);
